var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.047 24H0V0h35.653v24h-.606z",
    fill: "#1D5B99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.047 23.395H.605V.606h34.442v22.789z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m13.052 15.7 2.237-7.374h1.996L15.048 15.7h-1.996zm-.892-7.372-1.796 3.126c-.456.82-.724 1.233-.852 1.75h-.028c.032-.656-.06-1.461-.068-1.916l-.198-2.96h-3.36l-.034.198c.863 0 1.375.434 1.516 1.32l.655 5.855h2.067l4.181-7.373H12.16zM27.68 15.7l-.055-1.097-2.492-.002-.51 1.099h-2.166l3.929-7.361h2.659l.665 7.36h-2.03zm-.229-4.35c-.022-.546-.04-1.285-.004-1.733h-.029c-.121.366-.643 1.466-.872 2.006l-.743 1.617h1.75l-.102-1.89zm-8.071 4.56c-1.41 0-2.344-.447-3.012-.846l.95-1.452c.6.335 1.07.722 2.154.722.348 0 .683-.09.874-.42.277-.48-.064-.738-.844-1.18l-.385-.25c-1.155-.79-1.655-1.54-1.111-2.849.348-.837 1.266-1.472 2.781-1.472 1.044 0 2.024.452 2.594.893L22.29 10.34c-.557-.45-1.019-.678-1.547-.678-.421 0-.742.162-.852.382-.208.411.067.692.675 1.07l.457.29c1.404.886 1.738 1.813 1.386 2.68-.605 1.494-1.79 1.827-3.028 1.827zm10.924-6.586h-.086V8.8h.2c.127 0 .191.044.191.151 0 .096-.058.135-.137.144l.148.231h-.098l-.136-.225h-.082v.225zm.097-.299c.065 0 .122-.006.122-.082 0-.064-.062-.071-.114-.071h-.105v.153h.097zm-.003.503a.458.458 0 0 1-.468-.476c0-.286.216-.475.468-.475a.46.46 0 0 1 .466.475.46.46 0 0 1-.466.476zm0-.869c-.206 0-.366.162-.366.393 0 .216.14.393.366.393.204 0 .364-.16.364-.393 0-.231-.16-.393-.364-.393z",
    fill: "#1D5B99"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2 17.991H1.516v4.373H34.2v-4.373z",
    fill: "#E7A83A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.138 1.696H1.453V6.07h32.685V1.696zm-.747 20.358h-.087v-.527h.2c.127 0 .192.045.192.152 0 .095-.059.135-.137.143l.147.232h-.098l-.136-.225h-.081v.225zm.096-.3c.065 0 .123-.005.123-.082 0-.063-.063-.07-.114-.07h-.105v.153h.096zm-.002.503a.458.458 0 0 1-.468-.476c0-.285.216-.475.468-.475.25 0 .465.19.465.475a.46.46 0 0 1-.465.476zm0-.868c-.206 0-.366.161-.366.392 0 .217.14.393.366.393.203 0 .363-.16.363-.393 0-.23-.16-.392-.363-.392z",
    fill: "#1D5B99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsVisa);
export default __webpack_public_path__ + "static/media/Icons_visa.c73933d303a557938fefb9b743ed4064.svg";
export { ForwardRef as ReactComponent };